import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag, CheckCircle } from 'lucide-react';
const NAMES = ['María', 'Ana', 'Lucía', 'Sofía', 'Florencia', 'Camila', 'Valentina', 'Julieta', 'Martina', 'Paula'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'Salta', 'Tucumán', 'Neuquén', 'Santa Fe'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
      setData({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      // Hide after 4 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    // Initial delay
    const initialTimeout = setTimeout(showPopup, 5000);
    // Interval
    const interval = setInterval(showPopup, 20000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-8">
      {isVisible && <motion.div initial={{
      x: -300,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -300,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 100,
      damping: 20
    }} className="fixed bottom-4 left-4 z-50 bg-white rounded-lg shadow-xl border-l-4 border-green-500 p-4 max-w-xs flex items-center gap-4" data-id="element-9">
          <div className="bg-green-100 p-2 rounded-full" data-id="element-10">
            <ShoppingBag className="w-5 h-5 text-green-600" data-id="element-11" />
          </div>
          <div data-id="element-12">
            <p className="text-sm font-medium text-gray-900" data-id="element-13">
              <span className="font-bold" data-id="element-14">{data.name}</span> de {data.city}
            </p>
            <p className="text-xs text-gray-500 flex items-center gap-1" data-id="element-15">
              <CheckCircle className="w-3 h-3 text-green-500" data-id="element-16" />
              Compró el Mega Pack hace instantes
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}